// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "client-editor/" + {"599":"Gallery","965":"Scheduling"}[chunkId] + ".chunk.min.css";
};